@if(item.navCap && hasPermission){
  <div
    mat-subheader
    class="nav-caption"
    [class.nav-caption--module]="item.navCapEmphasis"
  >
    {{ item.navCap | translate }}
  </div>
  } @if(!item.navCap && !item.external && !item.twoLines && hasPermission) {
  <a
    mat-list-item
    (click)="onItemSelected(item)"
    [ngClass]="{
      'mat-toolbar mat-primary activeMenu': isItemActive(item),
      expanded: expanded,
      disabled: item.disabled,
      'menu-level-0': depth === 0,
      'menu-level-1': depth === 1,
      'menu-level-2': depth === 2
    }"
    class="menu-list-item {{ item.bgcolor }}"
    [style.padding-left.px]="depth > 0 ? 16 + (depth * 16) : 16"
  >
    <i-tabler
      class="routeIcon"
      name="{{ item.iconName }}"
      matListItemIcon
    ></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
    @if(item.children && item.children.length) {
    <span class="arrow-icon" fxFlex>
      <span fxFlex></span>
      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
        expand_more
      </mat-icon>
    </span>
    }
  </a>
  }
  
  <!-- external Link -->
  
  @if(!item.navCap && item.external) {
  <mat-list-item
    onClick="window.open('//google.com')"
    class="menu-list-item {{ item.bgcolor }}"
    target="_blank"
  >
    <i-tabler
      class="routeIcon"
      name="{{ item.iconName }}"
      matListItemIcon
    ></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
  </mat-list-item>
  }
  
  <!-- children -->
  @if(expanded && hasPermission) { @for(child of item.children; track child) {
  <app-nav-item
    [item]="child"
    (click)="onSubItemSelected(child)"
    [depth]="depth + 1"
  >
  </app-nav-item>
  } }
  